import React from 'react'
import { View, Text, Font, StyleSheet, Image } from '@react-pdf/renderer'
import { PropTypes } from 'prop-types'
import multimodalLogo from '../../../../images/illustrations/SEMCOG-MultiTool-Logo.png'
import { themeConfig } from '../../config/theme.config'
import SectionTitle from './SectionTitle'

const Scores = () => {
  const container = {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    flexDirection: 'row',
    padding: '10pt',
    height: 290
  }
  const title = {
    fontSize: 16,
    fontWeight: 700,
    alignSelf: 'center'
  }

  const numbers = {
    fontSize: 10,
    alignSelf: 'center',
    width: 150,

    textAlign: 'right'
  }
  return (
    <View style={[container]} debug={false} fixed={true}>
      <View
        style={{
          width: '90%',
          height: '100%',
          display: 'flex',
          alignContent: 'center',
          alignItems: 'center'
        }}
      >
        <SectionTitle sectionTitle="Average Score" />
      </View>
      {/* <View
        style={{
          width: '1%',
          height: '100%',
          borderLeft: '1pt',
          borderColor: themeConfig.semcogLightGray,
          borderLeftWidth: 1
        }}
      />
      <View
        style={{
          width: '48%',
          height: '100%',
          display: 'flex',
          alignContent: 'center',
          alignItems: 'center'
        }}
      >
        <SectionTitle sectionTitle="Weakest Link" />
      </View> */}
    </View>
  )
}

export default Scores

Scores.propTypes = {}
